import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonios } from '../data/testimonios';
import { Emoji } from './Emoji';
export function Testimonios() {
  return <section className="w-full bg-forest-900 py-14 sm:py-16" data-id="element-243" data-mp="39zmqem0wltct">
      <div className="mx-auto w-full max-w-[680px] px-4 text-center sm:px-6 lg:max-w-content" data-id="element-244" data-mp="35yauxzvcmdwp">
        <h2 className="inline-flex flex-wrap items-center justify-center gap-2 font-display text-[clamp(1.5rem,6vw,2.25rem)] font-extrabold leading-[1.08] tracking-tight text-cream" data-id="element-245" data-mp="30zzlhq8yu5f0">
          <Emoji symbol="❤️" className="text-3xl" data-id="element-246" data-mp="2r9wu1uhhszis" />
          Más personas que ya lo tienen
        </h2>

        <ul className="mt-9 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-247" data-mp="2mcwl9bt9dinz">
          {testimonios.map(item => <li key={item.name + item.initials} className="h-full" data-id="element-248" data-mp="2ibum0uzcd6m0">
              <figure className="flex h-full flex-col rounded-2xl border border-line bg-pistacho p-5 text-center shadow-card sm:p-6" data-id="element-249" data-mp="2dbgc17e6jmlc">
                <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-full bg-lime-200 font-display text-xs font-bold text-forest-800" aria-hidden="true" data-id="element-250" data-mp="28clt85g7py18">
                  {item.initials}
                </span>
                <span className="mt-3 flex justify-center gap-0.5" aria-label="5 de 5 estrellas" data-id="element-251" data-mp="1ed5zo6sgy0hf">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-252" data-mp="271bl6vrcjtib" data-mpi={index} />)}
                </span>
                <blockquote className="mt-4 text-[14px] leading-relaxed text-forest-900 sm:text-[15px]" data-id="element-253" data-mp="22174b4mj0wrk">
                  “{item.quote}”
                </blockquote>
                <figcaption className="mt-auto pt-4" data-id="element-254" data-mp="lpa81ghrayri">
                  <span className="block font-display text-sm font-bold text-forest-950" data-id="element-255" data-mp="qmk3pdvqo6ns">
                    {item.name}
                  </span>
                  <span className="mt-1 block text-xs text-forest-600/80" data-id="element-256" data-mp="6ma4ah64hvsp">
                    {item.location} · {item.product}
                  </span>
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}